import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import "./App.css";  
import Home from "./pages/home/Home"; 
import HeaderTop from "./Header";
import Footer from "./Footer"; 
import CmsPage from "./pages/CmsPage"; 
import VideoGallery from "./pages/VideoGallery";
import PhotoGalleryCategories from "./pages/PhotoGalleryCategories";
import PhotoGalleryPage from "./pages/PhotoGalleryPage";
import TestimonialForm from "./pages/TestimonialForm"; 
import FeedbackPage from "./pages/FeedbackPage"; 
import OurServices from "./pages/home/OurServices";
import OurCars from "./pages/home/OurCars";
import RoutesPage from "./pages/RoutesPage";
import ToursDetails from "./pages/ToursDetails";
import ToursList from "./pages/ToursList";
import ScrollToTop from "./pages/ScrollToTop";
import ContactPage from "./pages/ContactPage";
import TourPackages from "./pages/TourPackages";
import { MyApi } from "./MyApi";
import axios from "axios";
import FaqPage from "./pages/FaqPage";
import BlogPage from "./pages/BlogPage";
import BlogDetails from "./pages/BlogDetails";
 

function App() {
  const [setting, setSetting] = useState(null);

  // ✅ API call
  useEffect(() => {
    const fetchSetting = async () => {
      try {
        const res = await axios.get(
          MyApi.BASE_URL + "site-setting",
          {
            headers: { Authorization: MyApi.SECRET_KEY },
          }
        );

        if (res.data?.status) {
          setSetting(res.data.data);
        }
      } catch (error) {
        console.error("Setting API error:", error);
      }
    };

    fetchSetting();
  }, []);
  return (
    <Router>
      <ScrollToTop />
      <HeaderTop/>

      <Routes>
        {/* Home */}
        <Route path="/" element={<Home  />} />
        {/* Specific routes FIRST */}
        {/* <Route path="/services" element={<OurServices />} />  */}
        <Route path="/services/:categorySlug" element={<ToursList  setting={setting} />} />
        <Route path="/s/:categorySlug" element={<OurServices  setting={setting} />} />
        <Route path="tour-packages/:categorySlug" element={<TourPackages setting={setting} />}  />
        <Route path="/:categorySlug/:slug" element={<ToursDetails setting={setting} />} />
        <Route path="/our-cars" element={<OurCars setting={setting}/>} />
        <Route path="/routes" element={<RoutesPage />} />
        <Route path="/photo-gallery" element={<PhotoGalleryCategories />} />
        <Route path="/photo-gallery/:catId" element={<PhotoGalleryPage />} />
        <Route path="/video-gallery" element={<VideoGallery />} />
        <Route path="/reviews" element={<FeedbackPage />} />
        <Route path="/feedback-form" element={<TestimonialForm />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogDetails />} />
        {/* CMS page ALWAYS LAST */}
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/:slug" element={<CmsPage />} /> 
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;